import { z } from 'zod';

/**
 * プロダクトスコープ棚卸し 対象 Product 選択画面の URL search スキーマ。
 *
 * - freeText:        プロダクト名 / コードの部分一致検索（client 側で絞り込み）
 * - page / pageSize: ページネーション
 *
 * PN「リリースプラン作成」の product-targets と同じく、Product はステータス /
 * レベルを持たないため絞り込みは freeText のみ。
 */
export const productTargetsSearchSchema = z.object({
  page: z.coerce.number().min(1).optional().default(1),
  pageSize: z.coerce.number().min(1).optional().default(100),
  freeText: z.string().optional()
});
export type ProductTargetsSearch = z.infer<typeof productTargetsSearchSchema>;